{
    "option-symbol-quick-search-fields": [
        {
            "label": "Option ID", "columnname": "optionID", "placeholder": "Option ID",
            "width": "", "datatype": "String", "isLarge": false
        },
        {
            "label": "Primary Deliverable", "columnname": "primaryDeliverable", "placeholder": "Primary Deliverable",
            "width": "", "datatype": "String", "isLarge": true
        }
    ],
    "option-symbol-grid-columns": [
        {
            "display": "false",
            "ui_columnname": "Row No",
            "db_columnname": "RowNo",
            "datatype": "String",
            "mappingkey": "RowNo",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Option Kind",
            "db_columnname": "optionKind",
            "datatype": "String",
            "mappingkey": "optionKind",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Option ID",
            "db_columnname": "optionID",
            "datatype": "String",
            "mappingkey": "optionID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Primary Deliverable",
            "db_columnname": "primaryDeliverable",
            "datatype": "String",
            "mappingkey": "primaryDeliverable",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Exercise Style",
            "db_columnname": "exerciseStyle",
            "datatype": "String",
            "mappingkey": "exerciseStyle",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "true",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Settlement Type",
            "db_columnname": "settlementType",
            "datatype": "String",
            "mappingkey": "settlementType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "true",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Report Date",
            "db_columnname": "reportDate",
            "datatype": "String",
            "mappingkey": "reportDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Effective Date",
            "db_columnname": "effectiveDate",
            "datatype": "String",
            "mappingkey": "effectiveDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Expiry Date",
            "db_columnname": "expiryDate",
            "datatype": "String",
            "mappingkey": "expiryDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Updated User",
            "db_columnname": "updateUser",
            "datatype": "String",
            "mappingkey": "updateUser",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "",
            "dropdownvalue": ""
        }
    ]
}